<template>
  <div style="width:100px;height:100px;background-color:red">1</div>
</template>


<script>
export default {
  props: {
    stairIndex: {
      type: Number,
      default: 0
    },
    secondIndex: {
      type: Number,
      default: 0
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/newHomePage/infoView.vue